(() => {
  const root = document.querySelector('[data-ps-root]');
  if (!root) return;

  const variantThemes = {
    black: { ink:'#111417', 'ink-soft':'#24292e', paper:'#f3f1eb', 'paper-2':'#e8e5dc', accent:'#a8ff3e', 'accent-soft':'#d9ffac', 'photo-wash':'rgba(8,12,15,.18)' },
    white: { ink:'#14171a', 'ink-soft':'#3a3f43', paper:'#f7f7f4', 'paper-2':'#e8e8e2', accent:'#ff6b4a', 'accent-soft':'#ffd1c7', 'photo-wash':'rgba(255,255,255,.12)' },
    ocean: { ink:'#0d2530', 'ink-soft':'#254551', paper:'#edf3f3', 'paper-2':'#d7e5e6', accent:'#ffdb54', 'accent-soft':'#fff1ab', 'photo-wash':'rgba(18,58,72,.18)' },
    mojave: { ink:'#2e241d', 'ink-soft':'#5b493d', paper:'#f4ede2', 'paper-2':'#e5d6c3', accent:'#d8ff55', 'accent-soft':'#efffba', 'photo-wash':'rgba(63,44,28,.15)' }
  };
  const variantScenes = {};
  const selects = [...document.querySelectorAll('[data-ps-variant]')];
  const addButtons = [...document.querySelectorAll('[data-ps-add]')];
  const statuses = [...document.querySelectorAll('[data-ps-status]')];
  const variantImages = [...document.querySelectorAll('[data-ps-variant-image]')];
  const variantLabels = [...document.querySelectorAll('[data-ps-variant-label]')];

  function applyVariant(id) {
    const option = selects.flatMap(select => [...select.options]).find(item => item.value === id);
    if (!option) return;
    selects.forEach(select => { select.value = id; });
    root.dataset.variantId = id;
    const available = option.dataset.available === 'true';
    addButtons.forEach(button => {
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
    });
    const color = (option.dataset.color || option.textContent || 'black').trim().toLowerCase();
    const theme = variantThemes[color] || variantThemes.black;
    Object.entries(theme).forEach(([key,value]) => {
      root.style.setProperty(`--${key}`, value);
      document.querySelector('[data-ps-sticky]')?.style.setProperty(`--${key}`, value);
    });
    root.dataset.color = color;
    const scenes = variantScenes[color];
    if (scenes) document.querySelectorAll('[data-ps-scene]').forEach(image => {
      const source = scenes[image.dataset.psScene];
      if (source) image.src = source;
    });
    variantLabels.forEach(label => { label.textContent = option.dataset.color || option.textContent; });
    variantImages.forEach(node => {
      const role = node.dataset.psVariantImage || 'primary';
      const key = `image${role.charAt(0).toUpperCase()}${role.slice(1)}`;
      const image = option.dataset[key] || option.dataset.imagePrimary;
      if (image) node.src = image;
    });
  }
  selects.forEach(select => select.addEventListener('change', () => applyVariant(select.value)));
  if (selects[0]) applyVariant(selects[0].value);

  const tabs = [...document.querySelectorAll('[data-ps-carry]')];
  const carryImages = [...document.querySelectorAll('[data-ps-carry-image]')];
  const carryDescription = document.querySelector('[data-ps-carry-description]');
  const carryCopy = {
    crossbody:'Close, balanced, and ready at your chest. The adjustable strap keeps everyday essentials within reach without taking over your outfit.',
    belt:'Clip it at the waist when both hands have somewhere else to be. Its 0.6-pound build stays light while you move.',
    pouch:'Remove the strap and it becomes a compact organizer that moves cleanly from your work bag to your weekender.'
  };
  tabs.forEach(tab => tab.addEventListener('click', () => {
    const mode = tab.dataset.psCarry;
    tabs.forEach(item => { item.classList.toggle('is-active', item === tab); item.setAttribute('aria-selected', String(item === tab)); });
    carryImages.forEach(image => image.classList.toggle('is-active', image.dataset.psCarryImage === mode));
    if (carryDescription) carryDescription.textContent = carryCopy[mode];
  }));

  const featureCopy = {
    pocket:['01 · Quick access','The things you reach for first stay one motion away.','The exterior pocket keeps a phone, card wallet, or earbuds easy to grab without opening the main compartment.'],
    shell:['02 · 500D recycled nylon','A tougher outer layer for daily movement.','The recycled nylon exterior balances abrasion resistance with a compact, lightweight feel.'],
    zip:['03 · YKK zippers','Hardware chosen for repeat use.','The main opening and front pocket use dependable YKK zippers with easy-grab cord pulls.'],
    strap:['04 · Removable strap','Wear it three different ways.','Adjust it for cross-body carry, clip it around the waist, or remove it entirely to use the bag as a pouch.']
  };
  const tooltip = document.querySelector('[data-ps-tooltip]');
  document.querySelectorAll('[data-ps-hotspot]').forEach(button => button.addEventListener('click', () => {
    const key = button.dataset.psHotspot;
    const copy = featureCopy[key];
    document.querySelectorAll('[data-ps-hotspot]').forEach(item => item.setAttribute('aria-expanded', String(item === button)));
    if (!tooltip || !copy) return;
    tooltip.dataset.position = button.dataset.position;
    tooltip.querySelector('small').textContent = copy[0];
    tooltip.querySelector('h3').textContent = copy[1];
    tooltip.querySelector('p').textContent = copy[2];
    tooltip.classList.add('is-visible');
  }));
  document.querySelector('[data-ps-tooltip-close]')?.addEventListener('click', () => {
    tooltip?.classList.remove('is-visible');
    document.querySelectorAll('[data-ps-hotspot]').forEach(item => item.setAttribute('aria-expanded','false'));
  });

  const sticky = document.querySelector('[data-ps-sticky]');
  const hero = document.querySelector('[data-ps-hero]');
  if (sticky && hero) {
    const mobile = window.matchMedia('(max-width:700px)');
    let heroVisible = true;
    const update = () => sticky.classList.toggle('is-visible', mobile.matches || !heroVisible);
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; update(); }, { threshold:.12 }).observe(hero);
    mobile.addEventListener?.('change', update);
    update();
  }

  addButtons.forEach(button => button.addEventListener('click', async () => {
    const original = addButtons.map(item => item.innerHTML);
    addButtons.forEach(item => { item.disabled = true; item.textContent = 'Adding…'; });
    statuses.forEach(item => { item.textContent = ''; });
    try {
      const response = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body:JSON.stringify({ items:[{ id:Number(root.dataset.variantId), quantity:1 }] })
      });
      if (!response.ok) throw new Error('Unable to add');
      const ok = true;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      addButtons.forEach(item => { item.textContent = 'Added to cart'; });
      statuses.forEach(item => { item.textContent = ok ? 'Your sling is in the cart.' : 'The sling could not be added. Please try again.'; });
      if (ok && typeof window.fbq === 'function') window.fbq('track','AddToCart',{ content_ids:[root.dataset.variantId], content_type:'product', value:Number(root.dataset.price || 0), currency:'USD' });
    } catch (_) {
      addButtons.forEach(item => { item.textContent = 'Try again'; });
      statuses.forEach(item => { item.textContent = 'The sling could not be added. Please try again.'; });
    } finally {
      window.setTimeout(() => {
        addButtons.forEach((item,index) => { item.innerHTML = original[index]; });
        applyVariant(root.dataset.variantId);
      },1800);
    }
  }));

  if (typeof window.fbq === 'function') window.fbq('track','ViewContent',{ content_ids:[root.dataset.variantId], content_type:'product', value:Number(root.dataset.price || 0), currency:'USD' });
})();
